module.exports = __webpack_public_path__ + "img/zip.b6f1f8db.svg";